import React from 'react';

import { ButtonGroup, Grid, Icon, Segment } from 'semantic-ui-react';

import Button from '../Button';
import Popup from '../Popup/Popup';

import PlanningHorizontal from '../../assets/planning-horizontal.jpg';
import PlanningVertical from '../../assets/planning-vertical.jpg';
import { COULEUR_FOND_VIOLET } from '../../config/colors';

const ViewModeButton = (props) => {
    const {
        disabled,
        maximumSelectedVertical,
        mode: modeProps,
        onChange
    } = props;

    const [mode, setMode] = React.useState(modeProps);

    const handleClick = React.useCallback((value) => () => {
        if (onChange) {
            onChange(value);
        }

        setMode(value)
    }, [onChange]);

    React.useEffect(() => {
        if (modeProps) {
            setMode(modeProps);
        }
    }, [modeProps]);

    return ( 
        <ButtonGroup icon>
            <Popup
                position='bottom center'
                flowing
                mouseEnterDelay={1000}
                style={{ padding: 0 }}
                {...!disabled && { open: false }}
                content={(
                    <Grid padded>
                        <Grid.Row style={{ flexWrap: 'nowrap' }}>
                            <Grid.Column
                                as={Segment}
                                textAlign='center'
                                style={{
                                    padding: '1em 0',
                                    marginRight: 0,
                                    marginLeft: 0,
                                    borderRadius: '4px 0 0 4px',
                                    width: '22px',
                                }}
                                color='red'
                            >
                                <Icon
                                    fitted
                                    name='exclamation'
                                    style={{ fontStyle: 'italic' }}
                                />
                            </Grid.Column>
                            <Grid.Column
                                as={Segment}
                                verticalAlign='middle'
                                basic
                                width={16}
                                style={{ padding: 0 }}
                            >
                                <Segment
                                    basic
                                    style={{
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        marginBottom: 5,
                                        color: COULEUR_FOND_VIOLET,
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Nombre de salle sélectionnées maximum atteint
                                </Segment>
                                <Segment
                                    basic
                                    style={{
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        marginTop: 0,
                                        color: COULEUR_FOND_VIOLET
                                    }}
                                >
                                    <i>Dans ce mode d'affichage, {maximumSelectedVertical} salles au maximum peuvent être affichées</i>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
                trigger={(
                    <span>
                        <Button
                            {...mode === 'vertical' ? { className: 'btnSelected' } : null}
                            disabled={disabled}
                            onClick={handleClick("vertical")}
                            style={{
                                alignItems: 'center',
                                backgroundColor: 'transparent',
                                border: `2px solid ${COULEUR_FOND_VIOLET}`,
                                borderRight: 'none',
                                borderRadius: '5px 0 0 5px',
                                color: `${COULEUR_FOND_VIOLET}`,
                                display: 'flex',
                                height: '2.7rem',
                                justifyContent: 'center',
                                padding: '0.5em',
                                marginLeft: '0.5rem',
                            }}
                            content={
                                <img
                                    alt='planning-vertical'
                                    title='Planning vertical'
                                    style={{ height: 26 }}
                                    src={PlanningVertical}
                                />
                            }
                        />
                    </span>
                )} 
            />
            <Button
                {...mode === 'horizontal' ? { className: 'btnSelected' } : null}
                onClick={handleClick("horizontal")}
                style={{
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    border: `2px solid ${COULEUR_FOND_VIOLET}`,
                    borderLeft: 'none',
                    borderRadius: '0 5px 5px 0',
                    color: `${COULEUR_FOND_VIOLET}`,
                    display: 'flex',
                    height: '2.7rem',
                    justifyContent: 'center',
                    padding: '0.5em',
                    marginRight: '0.5rem',
                }}
                content={
                    <img
                        alt='planning-horizontal'
                        title='Planning horizontal'
                        style={{ height: 26 }}
                        src={PlanningHorizontal}
                    />
                }
            />
        </ButtonGroup>
    );
};

ViewModeButton.defaultProps = {
    defaultMode: 'horizontal'
}

export default ViewModeButton;